import css from './index.module.scss';
import { ENQUIRY_TYPE } from '@helpers/constants';
import { useState } from 'react';
import { IconNode, ToolTip, Typography } from '@components/base';
import Images from '@assets/images';
import { IWeightChildOption } from '@helpers/types/quotes';
import InternationalGenericInformation from './components/international';
import DomesticGenericInformation from './components/domestic';

interface IEnquiryGenericInformationProps {
  setQuoteFormState: any;
  selectedWeightSystemChildOptions: IWeightChildOption[];
  enquiryType?: string;
}

const EnquiryGenericInformation = (props: IEnquiryGenericInformationProps) => {
  const {
    setQuoteFormState,
    selectedWeightSystemChildOptions,
    enquiryType = ENQUIRY_TYPE.INTERNATIONAL
  } = props;

  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <main className={css.mainWrapper}>
      <div className={css.header}>
        <Typography variant="h5">Generic Information</Typography>
        <ToolTip title={isExpanded ? 'Collapse' : 'Expand'}>
          <div>
            <IconNode
              src={isExpanded ? Images.arrowUpBig : Images.arrowDownBig}
              onClick={() => setIsExpanded(!isExpanded)}
            />
          </div>
        </ToolTip>
      </div>
      {enquiryType === ENQUIRY_TYPE.INTERNATIONAL ? (
        <InternationalGenericInformation
          setQuoteFormState={setQuoteFormState}
          selectedWeightSystemChildOptions={selectedWeightSystemChildOptions}
          isExpanded={isExpanded}
        />
      ) : (
        <DomesticGenericInformation
          setQuoteFormState={setQuoteFormState}
          selectedWeightSystemChildOptions={selectedWeightSystemChildOptions}
          isExpanded={isExpanded}
        />
      )}
    </main>
  );
};

export default EnquiryGenericInformation;
